var Theme = /** @class */ (function () {
    function Theme() {
    }
    Theme.setThemeMode = function (mode) {
        document.documentElement.setAttribute('data-bui-theme', mode);
    };
    Theme.getThemeMode = function () {
        var mode = document.documentElement.getAttribute('data-bui-theme');
        return mode !== null && mode !== void 0 ? mode : 'light';
    };
    Theme.setDir = function (dir) {
        document.documentElement.setAttribute('dir', dir);
    };
    Theme.getDir = function () {
        var dir = document.documentElement.getAttribute('dir');
        return dir !== null && dir !== void 0 ? dir : 'ltr';
    };
    Theme.setTheme = function (theme) {
        var link = document.head.querySelector('link[href*="bluent.ui.theme"]');
        var href = link === null || link === void 0 ? void 0 : link.href;
        if (href && href.includes('bluent.ui.theme')) {
            var splits = href.split('/');
            var fileName = splits[splits.length - 1];
            href = href.replace(fileName, "bluent.ui.theme.".concat(theme, ".min.css"));
        }
        link.href = href;
    };
    return Theme;
}());
export { Theme };
